import { Br } from "@/components/molecules/Br";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { ProjectNav } from "@/components/organisms/ProjectNav";
import { AiCaseStudies } from "@/components/organisms/AiCaseStudies";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";
import leadProject from "/public/lead-project.svg";

export default function ProjectPage(props) {
  const isHeaderRelative = true;
  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={"プロジェクト事例"}
        pageDescription={
          "株式会社トッカシステムズのプロジェクト事例です。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/project/"}
        imgUrl={"/public/project-illust1.webp"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            {/* <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Project",
                },
              ]}
            /> */}
            <Inner className="pb-6 md:pb-20">
              {/* cover */}
              <div className="relative mb-6 box-border flex flex-col justify-end gap-4 bg-bgc-dark p-6 text-txt-base md:mb-8 md:aspect-21/9 md:gap-6 md:px-12 md:py-6 lg:mb-10 lg:flex-row lg:items-end lg:justify-between lg:px-12 lg:py-10 ">
                <div>
                  <h6 className="mb-6 text-sm font-bold text-pri md:text-md ">
                    Project
                  </h6>
                  <h2 className="relative aspect-3.48/1 h-auto 2xs:w-[200px] xs:w-[240px] md:w-[240px] lg:w-[334px]">
                    <Image
                      src={leadProject}
                      alt="システムを軸にした成長運用"
                      quality={80}
                      layout="fill"
                      objectFit="cover"
                    />
                  </h2>
                </div>
                <div>
                  <h3 className="mb-2 font-bold leading-comfort text-txt-base fluid-text-[14px,18px] md:mb-4">
                    企画から設計・製作・メンテナンスまで、
                    <Br tbpc />
                    一貫体制でお客さまの体験価値の向上に真摯に向き合います。
                  </h3>
                  <p className="text-xs text-txt-light">
                    ※各事例は、機密情報保持契約を遵守した上で、特定されないように配慮した上で掲載しています
                  </p>
                </div>
              </div>
              <ProjectNav />
              <AiCaseStudies />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
